import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { IclinicalTrials } from '../../interfaces/clinical-trials.interface';

@Component({
  selector: 'gen-clinical-trials',
  templateUrl: './clinical-trials.component.html',
  styleUrls: ['./clinical-trials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClinicalTrialsComponent implements OnInit {
  @Input() trials: IclinicalTrials[] = [];
  public metaData: any[];
  public open: boolean = false;
  constructor() {
    this.metaData = [
      {
        'label': 'Target',
        'key': 'target'
      },
      {
        'label': 'Nearest Recruiting Location',
        'key': 'distance.address'
      },
      {
        'label': 'Age Group',
        'key': 'ageGroup'
      },
      {
        'label': 'Contact',
        'key': 'contact'
      }
    ];
  }

  ngOnInit() {
  }

  getDataFromKey(data, key) {
    let keyArr = key.split('.'), result = data, i = 0;
    for (; i < keyArr.length; i++) {
      result = result && result.hasOwnProperty(keyArr[i]) && !!result[keyArr[i]] ? result[keyArr[i]] : 'Not Available';
    }
    return result;
  }

  openReferance(trialID) {
      const url = 'https://clinicaltrials.gov/ct2/show/' + trialID;
      window.open(url, '_blank');
  }
}
